import { render, staticRenderFns } from "./ExpeditionListCard.vue?vue&type=template&id=fd395608&scoped=true"
import script from "./ExpeditionListCard.vue?vue&type=script&lang=js"
export * from "./ExpeditionListCard.vue?vue&type=script&lang=js"
import style0 from "./ExpeditionListCard.vue?vue&type=style&index=0&id=fd395608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd395608",
  null
  
)

export default component.exports